/* app/js/src/components/common/goLiveButton/goLiveButton.component.scss */
.cursor-pointer {
  cursor: pointer;
}
:host {
  display: block;
  -ms-transform: translateY(0.2em);
  -webkit-transform: translateY(0.2em);
  transform: translateY(0.2em);
  margin-right: 30px;
}
:host.live button {
  background-color: #ef5350;
  color: #ffffff;
}
button {
  background-color: #141b22;
  color: #fff;
  border: none;
  padding: 0.3em 0.7em;
  text-align: center;
  border-radius: 4px;
  font-weight: 300;
  -webkit-transition: all 0.2s ease;
  transition: all 0.2s ease;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}
button span {
  font-size: 0.95em;
  line-height: 1.5em;
}
button:focus {
  outline: none;
}
/*# sourceMappingURL=goLiveButton.component.css.map */
